export const DEFAULT_VIDEO_PLAYER_CONFIG = {
  width: '100%',
  height: '100%',
  controls: true,
  autoplay: false,
  muted: false,
  loop: false,
  timelineHeight: 12,
  breakpointSize: 8,
  volume: 0.8,
} as const;

export const BREAKPOINT_TOLERANCE = 0.5; // seconds

export const LOADING_OVERLAY_DELAY_MS = 150;
export const IDLE_SUSPEND_GRACE_MS = 750;
export const MAX_LOADING_OVERLAY_MS = 15_000;
export const COVER_TIMEOUT_MS = 30_000;
export const SLOW_LOADING_HINT_MS = 5_000;
export const VIDEO_PLAYER_CROSS_ORIGIN = 'anonymous';

export const FULLSCREEN_EVENTS = [
  'fullscreenchange',
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'msfullscreenchange',
] as const;

export const TIMELINE_HEIGHT = 16; // Match Figma design
export const BREAKPOINT_SIZE = 4; // Match Figma design

export const CONTROL_BUTTON_CLASSES = {
  base: 'transition-colors hover:text-gray-300 focus:outline-hidden rounded-sm p-1 ring-0 ring-transparent',
  playPause: 'size-4',
  volume: 'size-4',
  fullscreen: 'size-4',
  skip: 'size-4',
} as const;

export const SIGNED_URL_EXPIRY_MARGIN_MS = 5 * 60_000;

export const URL_REFRESH_REARM_DISTANCE_SECONDS = 2;
